import React, { useEffect, useState } from 'react';
import { ILegalRequirement } from '../../Interfaces/ILegalRequirement';
import { IDocument } from '../../Interfaces/IDocument';
import { Chip, Tooltip } from '@mui/material';
import { ContactPage, InsertDriveFile } from '@mui/icons-material';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { LegalRequirementDocumentDialog } from './LegalRequirementDocumentDialog';

interface IProps {
  legalRequirementObject: ILegalRequirement;
  setLegalRequirementObject: Function;
  isNotDisabled: boolean;
  downloadedArray?: IDocumentDownloaded[];
  /** Mandanten des Vorgangs — ohne sie bleibt die Spalte "Mandant" in
   *  der Download-Uebersicht leer (QS #16). */
  legalClients?: ILegalClient[];
}

export const LegalRequirementDocuments: React.FC<IProps> = ({
  legalRequirementObject,
  setLegalRequirementObject,
  isNotDisabled,
  downloadedArray,
  legalClients,
}) => {
  const [documentArrayClient, setDocumentArrayClient] = useState<IDocument[]>(
    legalRequirementObject.DocumentArrayClient === undefined
      ? []
      : legalRequirementObject.DocumentArrayClient
  );

  const [documentArrayEmployees, setDocumentArrayEmployees] = useState<
    IDocument[]
  >([]);

  const isSendEmailPossible =
    legalRequirementObject.sendMail ||
    legalRequirementObject.isInterneLegalRequirement;

  useEffect(() => {
    const updatedArray = legalRequirementObject.DocumentArrayEmployees
      ? legalRequirementObject.DocumentArrayEmployees.map(doc => ({
          ...doc,
          perEmail: isSendEmailPossible ? doc.perEmail : false,
        }))
      : [];

    setDocumentArrayEmployees(updatedArray);
  }, [isSendEmailPossible]);

  const [isOpenClient, setIsOpenClient] = useState(false);
  const [isOpenEmployees, setIsOpenEmployees] = useState(false);

  const hanldeOpenEmployees = () => {
    setDocumentArrayEmployees(
      legalRequirementObject.DocumentArrayEmployees === undefined
        ? []
        : legalRequirementObject.DocumentArrayEmployees
    );
    setIsOpenEmployees(true);
  };

  const handleSave = () => {
    setLegalRequirementObject({
      ...legalRequirementObject,
      DocumentArrayEmployees: documentArrayEmployees,
      DocumentArrayClient: documentArrayClient,
    } as ILegalRequirement);
    setIsOpenEmployees(false);
    setIsOpenClient(false);
  };

  return (
    <>
      <LegalRequirementDocumentDialog
        open={isOpenClient}
        onClose={() => setIsOpenClient(false)}
        title='Daten vom Mandanten'
        allowUpload={false}
        allowRemove={true}
        documentArray={documentArrayClient}
        setDocumentArray={setDocumentArrayClient}
        downloadedArray={downloadedArray}
        legalClients={legalClients}
        legalRequirementObject={legalRequirementObject}
        handleSave={handleSave}
      />

      <LegalRequirementDocumentDialog
        open={isOpenEmployees}
        onClose={() => setIsOpenEmployees(false)}
        title='Für den Mandant bereitgestellte Daten'
        allowUpload={true}
        allowRemove={true}
        documentArray={documentArrayEmployees}
        setDocumentArray={setDocumentArrayEmployees}
        downloadedArray={downloadedArray}
        legalClients={legalClients}
        legalRequirementObject={legalRequirementObject}
        handleSave={handleSave}
        isStandarddocument
        isSendEmailPossible={isSendEmailPossible}
      />

      {documentArrayClient.length > 0 &&
        legalRequirementObject.canUploadFilesClient && (
          <Tooltip title={'Herunterladen von Mandantendaten'}>
            <Chip
              icon={<ContactPage />}
              label={documentArrayClient.length}
              onClick={() => setIsOpenClient(true)}
              disabled={!isNotDisabled}
              variant='outlined'
              sx={{ marginRight: 1 }}
            />
          </Tooltip>
        )}
      {legalRequirementObject.canUploadFilesEmployees && (
        <Tooltip title={'Daten für Mandanten hochladen'}>
          <Chip
            icon={<InsertDriveFile />}
            label={documentArrayEmployees.length}
            onClick={hanldeOpenEmployees}
            disabled={!isNotDisabled}
            variant='outlined'
          />
        </Tooltip>
      )}
    </>
  );
};
